module.exports = "/_next/static/images/confetti-5dc512d7a02d1c295b7ef2c5c7469fec.svg";